import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { Trans } from 'client/components/Trans/Trans'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type TProps = {}
const CONTENT = [
  [0, 0, 0, 0, 0],
  [0, 0, 3, 0, 0, 0],
  [0],
  [0, 0, 0, 0, 0],
  [0, 0, 0],
  [2, 2, 2, 3, 1],
  [0, 0, 0, 5],
  [0, 0, 0, 0],
  [0, 0],
  [0, 0],
]

const RefundPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.RefundPage)
  return (
    <div className="flex flex-1 flex-col gap-20 py-20">
      <ResponsiveBlock>
        <div className="flex flex-col gap-20">
          <Text tagName="h1" className="text-palette-white font-body---40px uppercase">
            {t('title')}
          </Text>
        </div>
      </ResponsiveBlock>
      <ResponsiveBlock>
        <div className="flex w-full flex-col gap-12">
          {CONTENT.map((parts, blockIndex) => {
            const blockNumber = blockIndex + 1
            return (
              <div key={blockNumber} className="flex flex-col gap-8">
                <Text tagName="h4" className="text-palette-grey--alt font-body---24px font-normal">
                  {`${blockNumber}. ${t(`text_blocks.${blockNumber}.title`)}`}
                </Text>
                <ul className="flex flex-col gap-2">
                  {parts.map((textsNumber, partIndex) => {
                    const partNumber = partIndex + 1
                    const caption = t(`text_blocks.${blockNumber}.parts.${partNumber}.caption`)
                    const textsCaption = t(`text_blocks.${blockNumber}.parts.${partNumber}.texts.caption`)
                    return (
                      <li key={partNumber} className="flex flex-col gap-4">
                        {caption && (
                          <Text
                            tagName="span"
                            className="text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                          >
                            <Trans
                              i18nKey={`${blockNumber}.${partNumber}. ${caption}`}
                              ns={ClientLocaleNS.PrivacyPage}
                            ></Trans>
                          </Text>
                        )}
                        {textsNumber > 0 && (
                          <div className="flex flex-col gap-2">
                            {textsCaption && (
                              <Text
                                tagName="span"
                                className="text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                              >
                                <Trans
                                  i18nKey={`text_blocks.${blockNumber}.parts.${partNumber}.texts.caption`}
                                  ns={ClientLocaleNS.RefundPage}
                                ></Trans>
                              </Text>
                            )}
                            <ul className="flex flex-col gap-2">
                              {Array(textsNumber)
                                .fill(null)
                                .map((_, listIndex) => {
                                  const listItemNumber = listIndex + 1
                                  return (
                                    <li
                                      key={listItemNumber}
                                      className="flex gap-2 text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                                    >
                                      <Text tagName="span" className="">
                                        {`   ${listItemNumber}.`}
                                      </Text>
                                      <Text tagName="span" className="">
                                        <Trans
                                          i18nKey={t(
                                            `text_blocks.${blockNumber}.parts.${partNumber}.texts.${listItemNumber}`,
                                          )}
                                          ns={ClientLocaleNS.RefundPage}
                                        ></Trans>
                                      </Text>
                                    </li>
                                  )
                                })}
                            </ul>
                          </div>
                        )}
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          })}
        </div>
      </ResponsiveBlock>
    </div>
  )
}

export { RefundPageContent }
